import { observer } from 'mobx-react-lite'
import { type BookkeepingProgressionViewModel } from './BookkeepingProgressionViewModel'
import {
  getPrimaryActionTestId,
  getSecondaryActionTestId,
} from './bookkeeping-step-test-ids'
import { BookkeepingProgressionCard } from '@/features/jobs/details/components/BookkeepingProgressionCard'
import { ContentError } from '@/components/ContentError'

export interface BookkeepingProgressionCardContainerProps {
  vm: BookkeepingProgressionViewModel
}

export const BookkeepingProgressionCardContainer = observer(
  function BookkeepingProgressionCardContainer({
    vm,
  }: BookkeepingProgressionCardContainerProps) {
    const card = () =>
      vm.bookkeepingStepInfo && (
        <BookkeepingProgressionCard
          bookkeepingStepInfo={vm.bookkeepingStepInfo}
          primaryActionTestId={getPrimaryActionTestId(vm.bookkeepingStep)}
          secondaryActionTestId={getSecondaryActionTestId(vm.bookkeepingStep)}
        />
      )

    // Until the progression loads, the card shows the job being set up.
    return vm.fetch.match({
      pending: card,
      rejected: (err) => (
        <ContentError
          size="section"
          title="An error occurred while loading the bookkeeping progression."
          error={err}
        />
      ),
      resolved: card,
    })
  },
)
